module.exports = __webpack_public_path__ + "static/media/screenshot-10.a42fce89.jpg";